module.exports = __webpack_public_path__ + "media/images/icon_cancel-48700322e04eb938bdd9d8ec208de948.svg";